/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Lambdas { 
    /**
     * Lambda Function Name
     */
    name: string;
    /**
     * Description text of Lambda function
     */
    description: string;
    /**
     * Last modified timestamp for lambda
     */
    last_modified: any | null;
    /**
     * Maximum memory for the lambda function
     */
    max_memory?: any | null;
}

